import React from 'react';
import { classnames } from '@/utils/classnames/classnames';
import { useTabs } from '../../context';
import { Props } from './types';

const Panels = ({ children, className }: React.PropsWithChildren<Props>) => {
  const { activeTabIndex, baseId } = useTabs();
  const safeIndex = Math.min(React.Children.count(children) - 1, Math.max(0, activeTabIndex));

  return (
    <div
      role="tabpanel"
      id={`${baseId}-panel-${safeIndex}`}
      aria-labelledby={`${baseId}-tab-${safeIndex}`}
      tabIndex={0}
      className={classnames('overflow-auto pt-4 lg:pt-6', className)}
    >
      {React.Children.toArray(children)[safeIndex]}
    </div>
  );
};

export default Panels;
